export const TRACK_STATUS_URL = 'https://enquiry.icegate.gov.in/enquiryatices/index.jsp';